function brindeCustom() {
    //namorados
    const namoradosActive = true;

    const brindes = {
        "499": ["50166735733033", "50166839673129", "50166839738665", "50166824698153"],
        "lift": ["50065676796201", "50065614176553"],
        "sacola": ["50064207446313"],
    };


    //outros brindes
    const valorMinimo = 499;
    const minLift = 2;
    const minQuantidade = 4;

    let isRunning = false;

    async function updateCart() {
        const res = await fetch('/?sections=cart-drawer');
        const data = await res.json();

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data['cart-drawer'];

        const novoConteudo = tempDiv.querySelector('cart-drawer');
        const drawerAtual = document.querySelector('cart-drawer');

        if (novoConteudo && drawerAtual) {
            drawerAtual.innerHTML = novoConteudo.innerHTML;
            
            // Dispatch cart:updated with debounce using the same system
            const CartDrawer = customElements.get('cart-drawer');
            if (CartDrawer) {
              clearTimeout(CartDrawer.cartUpdateTimeout);
              CartDrawer.cartUpdateTimeout = setTimeout(() => {
                document.dispatchEvent(new CustomEvent('cart:updated'));
              }, CartDrawer.CART_UPDATE_DEBOUNCE || 300);
            } else {
              // Fallback if CartDrawer class not found
              setTimeout(() => {
                document.dispatchEvent(new CustomEvent('cart:updated'));
              }, 300);
            }
        }

        // Hide spinner after updating cart drawer
        hideLoadingSpinner();

        // Gift eligibility will be recalculated by cart:updated listeners.
    }

    async function adicionarBrindes(tipo) {
        showLoadingSpinner(); // Show spinner before adding
        
        const items = brindes[tipo].map(brinde => ({
            quantity: 1,
            id: brinde,
            properties: { brinde: tipo }
        }));

        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
        });
        
        // After adding, update the cart drawer
        await updateCart();
    }

    async function removerBrindes(tipo, cart) {
        const itemsToUpdate = {};
        const isSeletorCampaign = (window.CONFIG?.gifts || []).some(gift => gift.label === tipo);

        for (const item of cart.items) {
            const isBrindeDoTipo = item.properties?.brinde === tipo;

            if (isSeletorCampaign && isBrindeDoTipo) {
                itemsToUpdate[item.variant_id] = 0;
            }

            if (!isSeletorCampaign && brindes[tipo]?.includes(item.variant_id) && isBrindeDoTipo) {
                itemsToUpdate[item.variant_id] = 0;
            }
        }

        if (Object.keys(itemsToUpdate).length > 0) {
            showLoadingSpinner(); // Show spinner before removing
            
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates: itemsToUpdate })
            })
                .then(response => response.json())
                .catch((error) => {
                    console.error('Error:', error);
                });
            
            // Only update cart drawer if we actually removed items
            await updateCart();
        }
    }


    function showLoadingSpinner() {
        const loadCart = document.querySelector('#loadCart');
        const btnFinish = document.querySelector('.button_finish');
        if (loadCart) {
            loadCart.style.opacity = '1';
            loadCart.style.visibility = 'visible';
            btnFinish.disabled = true;
        }
    }

    function hideLoadingSpinner() {
        const loadCart = document.querySelector('#loadCart');
        const btnFinish = document.querySelector('.button_finish');
        if (loadCart) {
            loadCart.style.opacity = '0';
            loadCart.style.visibility = 'hidden';
            btnFinish.disabled = false;
        }
    }

    async function verificarProdutoNoCarrinho() {
        if (isRunning) return;
        isRunning = true;


        try {
            const getCart = () => fetch('/cart.js').then(r => r.json());
            let cart = await getCart();

            const total = cart.total_price;
            const quantidadeTotal = cart.items.reduce((acc, item) => {
                return item.properties?.brinde ? acc : acc + item.quantity;
            }, 0);

            // -------- VALIDAÇÃO 1: COMPRA >= R$499 --------
            const temBrinde499 = cart.items.some(item =>
                item.properties?.brinde === "499"
            );

            if (false) {
                if ((total / 100) >= valorMinimo) {
                    if (!temBrinde499) {
                        await adicionarBrindes("499");
                        cart = await getCart();
                    }
                } else if (temBrinde499) {
                    await removerBrindes("499", cart);
                    cart = await getCart();
                }
            }

            // -------- VALIDAÇÃO 2: 2+ produtos da coleção LIFT --------
            const liftCount = cart.items.reduce((acc, item) => {
                return item.product_type?.toLowerCase().includes('lift') ? acc + item.quantity : acc;
            }, 0);

            const temBrindeLift = cart.items.some(item =>
                brindes["lift"].includes(String(item.id)) && item.properties?.brinde === "lift"
            );

            if (false) {
                if (liftCount >= minLift) {
                    if (!temBrindeLift) {
                        await adicionarBrindes("lift");
                        cart = await getCart();
                    }
                } else if (temBrindeLift) {
                    await removerBrindes("lift", cart);
                    cart = await getCart();
                }
            }

            // -------- VALIDAÇÃO 3: 4+ produtos no carrinho --------
            const temBrindeSacola = cart.items.some(item =>
                item.properties?.brinde === "sacola"
            );

            if (false) {
                if (quantidadeTotal >= minQuantidade) {
                    if (!temBrindeSacola) {
                        await adicionarBrindes("sacola");
                        cart = await getCart();
                    }
                } else if (temBrindeSacola) {
                    await removerBrindes("sacola", cart);
                    cart = await getCart();
                }
            }



            // -------- VALIDAÇÃO 4: BRINDES COM SELETOR (campanhas independentes) --------
            // Cada entrada ativa do metaobjeto brinde_seletor é uma campanha própria (produto +
            // valor mínimo). O brinde é adicionado manualmente pelo modal de seleção
            // (modal-gift-selector); aqui apenas removemos, campanha a campanha, quando o
            // carrinho deixa de atingir o valor mínimo daquela campanha.
            const giftCampaigns = window.CONFIG?.gifts || [];

            if (namoradosActive && giftCampaigns.length > 0) {
                let totalCarrinho = 0;

                document.querySelectorAll('#CartDrawer-CartItems .cart-item').forEach(item => {
                    if (!item.classList.contains('giftt')) {
                        const quantity = parseInt(item.getAttribute('data-quantity'), 10) || 0;
                        const price = parseFloat(item.getAttribute('data-price')) || 0;
                        totalCarrinho += price * quantity;
                    }
                });

                for (const gift of giftCampaigns) {
                    const hasGift = cart.items.some(item => item.properties?.brinde === gift.label);
                    const hasApto = totalCarrinho >= gift.minTotal;

                    if (!hasApto && hasGift) {
                        await removerBrindes(gift.label, cart); // This will call updateCart() internally if items removed
                        cart = await getCart();
                    }
                }
            }

        } catch (error) {
            console.error('Erro ao verificar brindes:', error);
        } finally {
            isRunning = false;
        }
    }


    // Reexecutar ao interagir com botões do carrinho
    document.addEventListener('click', (event) => {
        const selectors = [
            '.cart-item__quantity .quantity__button',
            '.cart-item__details cart-remove-button',
            '#addcartfixed',
            '#buy-button',
            '.selectorMob .buy',
            '#btn-adicionar-brindes',
            '.product-image-wrapper .actions .buy'
        ];

        if (selectors.some(sel => event.target.closest(sel))) {

            setTimeout(() => {
                isRunning = false;
                verificarProdutoNoCarrinho();

            }, 3000);
        }
    });
}

brindeCustom();
